import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink, useParams} from 'react-router-dom';

import {
  TableCell,
  TableFooter,
  TableRow,
  makeStyles
} from "@material-ui/core";

// material
import {
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle,
  } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

import {api, reiniciarToken, consultaDespesasVendas, excluirDespesas} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { fFormataDinheiro} from '../../utils/formatNumber';

import CadDespesaVendaForms from '../FormsTemplates/Despesa/CadastroDespesaVendaForms';

// utils
import { fDatePadrao } from '../../utils/formatTime';


export default function VendaAvulsa() {
  
  const {id} = useParams();  
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);
  let sumValorDespesa;

  const getDespesas = async () => {
    setData([]);
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }
    
    const response = await consultaDespesasVendas(id);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        setData(dados => [...dados, {id_despesa: valores.id_despesa, 
                                     descricao: valores.descricao, 
                                     data_pagamento: fDatePadrao(valores.data_pagamento), 
                                     valor_pagamento: valores.valor_pagamento,
                                     valor_pagto_formatado: fFormataDinheiro(valores.valor_pagamento)}]);
      });
    }; 
  }

  useEffect(() => {
    setData([]);
    getDespesas();
  },[]) 

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 

  const excluirDespesa = async (id) => {
    const response = await excluirDespesas(id);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getDespesas();
    }; 
  } 

  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluirDespesa(dados[dataIndex].id_despesa)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Excluir" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }
                  ,{name:"id_despesa", label: "Código"} 
                  ,{name:"descricao", label: "Descrição"}
                  ,{name:"data_pagamento", label: "Data Pagamento"}
                  ,{name:"valor_pagto_formatado", label: "Valor do Pagamento"}
                  ];

  const useStyles = makeStyles((theme) => ({
    footerCell: {
        backgroundColor: "#cccccc",
        borderBottom: "none",
        color: "black",
        fontSize: 14,
        fontWeight: 'bold'
      }
  }));

  const classes  = useStyles();

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
    selectToolbarPlacement: "none",
    download: 'false',
    viewColumns: 'false',
    customTableBodyFooterRender: (opts) => {
        
        sumValorDespesa = dados
          .reduce((total, item) => {
            return (total +  item.valor_pagamento);
        }, 0);

        return (
          <>
            {dados.length > 0 && (
              <TableFooter className={classes.footerCell}>
                <TableRow>
                {opts.selectableRows !== 'none' ? <TableCell className={classes.footerCell} /> : null}
                  {opts.columns.map((col, index) => {
                    if (col.display === "true") {
                      if (col.name === "data_pagamento") {
                        return (
                          <TableCell key={index} className={classes.footerCell}>
                            TOTAL
                          </TableCell>
                        );
                      }if (col.name === "valor_pagto_formatado") {
                        return (
                          <TableCell key={index} className={classes.footerCell}>
                            {fFormataDinheiro(sumValorDespesa)}
                          </TableCell>
                        );
                      }  
                      if (col.name !== "data_pagamento" && col.name !== "valor_pagto_formatado") {
                        return <TableCell key={index} className={classes.footerCell}/>
                      };
                    }
                    return <TableCell key={index} className={classes.footerCell}/>;
                    })
                  }
                </TableRow>
              </TableFooter>
            )}
          </>
        );
    }
  };             
                    
  return (
    <Page title="Despesas Venda">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Cadastro de Despesa
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained"  color="neutral" component={RouterLink} to="/venda/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>

        <Stack mb={2} spacing={10}>
          <CadDespesaVendaForms/>
        </Stack>

        <Stack spacing={3}>
          {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
          {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
        </Stack > 

        <Stack mb={2} spacing={10}>
          <MUIDataTable
              data={Object.values(dados)}
              columns={columns}  
              options={options} 
          />
        </Stack>
      </Container>  
    </Page>  
  );
}
